"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _options = require("../options");

var _refreshJWT = _interopRequireDefault(require("../apollo/refreshJWT"));

var _repeatWithHeaders = _interopRequireDefault(require("./repeatWithHeaders"));

function _default(_ref) {
  var networkError = _ref.networkError,
      operation = _ref.operation,
      forward = _ref.forward;
  if (!operation || !forward) return;
  return (0, _repeatWithHeaders["default"])( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _refreshJWT["default"])((0, _options.getOptions)());

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    operation: operation,
    forward: forward
  });
}